import {
  enableDevValidations,
  ModuleRegistry,
  provideGlobalGridOptions,
} from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import 'common/components/ag-grid/FilterActions.less';

// v36+ leaves validations out of AllEnterpriseModule; without them warnings are bare error codes
if (process.env.NODE_ENV === 'development') {
  enableDevValidations();
}

// Register all AG Grid enterprise (+ community) modules globally once.
// ModuleRegistry.registerModules is idempotent — safe to call multiple times.
ModuleRegistry.registerModules([AllEnterpriseModule]);

// v33+ defaults suppressMenuHide to true (menu button always visible); restore the
// pre-upgrade behaviour of showing it only on header hover.
provideGlobalGridOptions({
  // Keep the user's dragged order when React supplies updated column definitions.
  maintainColumnOrder: true,
  // v33+ "new" menu adds a separate filter button to every header, truncating titles
  columnMenu: 'legacy',
  suppressMenuHide: false,
  // header menu button: hamburger (ag-icon-menu) instead of the v33+ default menu-alt
  icons: {
    menuAlt:
      '<span class="ag-icon ag-icon-menu" unselectable="on" role="presentation"></span>',
  },
});

LicenseManager.setLicenseKey(process.env.REACT_APP_LICENSE_KEY_AGGRID);
